import template from "./bOvertimeApplicationForm.html";
import moment from "moment";
import _ from 'lodash';
import angular from "angular";

export function bOvertimeApplicationFormDirective() {
  'ngInject';

  const directive = {
    restrict: 'E',
    template: template,
    controller: bOvertimeApplicationFormController,
    controllerAs: 'bOvertimeApplicationForm',
    bindToController: true,
    scope: {
      employeeView: "=?",
      clientsOptions: "=?",
      supervisors: "=?",
      defaultValues: "=?",
      employees: "=?",
      sendApplication: "&",
      closeForm: "&",
      viewMode: "=?",
      firstValidStartAtDate: "=?",
      isLoading: "="
    }
  };

  return directive;
}

class bOvertimeApplicationFormController {
  constructor($scope, OvertimeApplications) {
    'ngInject';

    this.values = {
      clients: [],
      acceptingUsers: [],
      users: []
    };

    this.$onInit = () => {
      this.OvertimeApplications = OvertimeApplications;

      if (this.defaultValues) {
        this.durationFormatInvalid = false;
        Object.entries(this.defaultValues).map(([key, value]) => this.values[key] = value);
        if (!this.employeeView)
          this.values.users = this.employees.filter(employee => employee.id === this.values.userId);
        else
          this.values.users = undefined;

        this.canRequestChanges = this.defaultValues.requestChanges;

        this.users = angular.copy(this.values.users);
        this.clients = angular.copy(this.values.clients);
        this.acceptingUsers = angular.copy(this.values.acceptingUsers);
      }

      this.multiSelectSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 2,
        checkBoxes: true,
        scrollableHeight: '250px',
        scrollable: true,
        enableSearch: true,
      };

      this.clientsMultiSelectSettings = {
        ...this.multiSelectSettings,
        // showCheckAll: true,
        // showUncheckAll: true,
        displayProp: 'displayName',
        searchField: 'displayName'
      };

      this.approversMultiSelectSettings = {
        ...this.multiSelectSettings,
        displayProp: 'fullName',
        searchField: 'fullName'
      };

      this.employeeMultiSelectSettings = {
        ...this.multiSelectSettings,
        displayProp: 'fullName',
        closeOnSelect: true,
        closeOnDeselect: true,
        searchField: 'fullName'
      };

      this.employeeMultiSelectEvents = {
        onItemSelect: (data) => this.selectEmployee(data),
        onItemDeselect: (data) => this.deselectEmployee(data)
      };
    };

    $scope.$on("$destroy", () => {
      clearTimeout(this.updateHoursFunction);
    });
  }

  formIsAccepted() {
    if (this.employeeView && this.values.id && !this.values.employeeAccepted)
      return true;
  }

  formIsInvalid() {
    if (
      this.values.startAt
      && this.firstValidStartAtDate
      && (
        this.values.startAt === ''
        || moment(this.values.startAt).isBefore(moment(this.firstValidStartAtDate), 'day')
      )
    )
      this.startAtError = true;
    else
      this.startAtError = false;

    if (this.values.endAt && (this.values.endAt === '' || moment(this.values.endAt).isBefore(moment(this.values.startAt))))
      this.endAtError = true;
    else
      this.endAtError = false;

    if (this.startAtError || this.endAtError)
      return true;

    return (
      !this.values.startAt
      || !this.values.endAt
      || !this.values.duration
      || this.durationFormatInvalid !== false
      || (!this.values.clients || this.values.clients.length === 0)
      || (!this.employeeView && !this.values.userId)
    );
  }

  turnObjectIntoStringOfIds(arr) {
    if (!arr)
      return '';

    return arr.map(elem => elem.id).sort().toString();
  }

  formWasntTouched() {
    if (!this.defaultValues)
      return false;

    return Object
      .entries(this.values)
      .every(([key, value]) => {
        return ['clients', 'users', 'acceptingUsers'].includes(key)
          ? _.isEqual(this.turnObjectIntoStringOfIds(this.defaultValues[key]), this.turnObjectIntoStringOfIds(this[key]))
          : _.isEqual(this.defaultValues[key], value);
      })
      || !this.values
      || this.values.comment === '';
  }

  send() {
    const data = angular.copy(this.values);
    data.clients = this.values.clients.map(client => client.id);
    data.acceptingUsers = this.values.acceptingUsers.map(acceptingUser => acceptingUser.id);
    this.sendApplication({data});
  }

  formatNumberToTime(hours) {
    const formattedHours = hours.replaceAll(',', '.');
    const duration = moment.duration(formattedHours, 'hours');

    const timePart = (timePart) => {
      return timePart < 10 ? `0${timePart}` : timePart;
    };

    return `${timePart(Math.floor(duration.asHours()))}:${timePart(duration.get('minutes'))}:${timePart(duration.get('seconds'))}`;
  }

  updateDuration() {
    clearTimeout(this.updateHoursFunction);
    this.updateHoursFunction = setTimeout(() => {
      const format = /^(\d+:[0-5]\d:[0-5]\d|\d*([,.]\d*)|\d*)$/;
      const numberFormat = /^(\d*([,.]\d*)|\d*)$/;
      const match = this.values.duration.match(format);

      if (!match) {
        this.durationFormatInvalid = true;
        return;
      } else {
        if (this.values.duration.match(numberFormat))
          this.values.duration = this.formatNumberToTime(this.values.duration);
      }

      if (moment.duration(this.values.duration).asMilliseconds() === 0) {
        this.durationFormatInvalid = true;
        return;
      }

      this.durationFormatInvalid = false;
    }, 500);
  }

  getClients() {
    this.state = 'loading';

    this.OvertimeApplications.managerOrTLCreateView(this.values.userId).then(
      (success) => {
        this.clientsOptions = success.data.clients.sort((a, b) => a.name.localeCompare(b.name)).map(client => {
          client.displayName = (client.additionalInfo ? `(${client.additionalInfo}) ` : "") + client.name;
          return client;
        });
        this.firstValidStartAtDate = success.data.firstValidStartAtDate;
        this.allClientsSelected = false;
        this.values.clients = [];
        this.state = 'loaded';
      }
    );
  }

  selectEmployee(data) {
    this.values.userId = data.id;
    this.values.users = this.values.users.filter(user => user.id === data.id);

    this.getClients();
  }

  deselectEmployee() {
    this.values.userId = null;
    this.values.clients = [];
    this.clientsOptions = [];
  }

  toggleAllClients() {
    if (this.allClientsSelected)
      this.values.clients = this.clientsOptions;
    else
      this.values.clients = [];
  }
}
